import React, { useEffect } from "react"
import { AppBar, Toolbar, IconButton, Box } from "@mui/material"
import Tooltip from "@mui/material/Tooltip"
import Profile from "./Profile"
import FullscreenButton from "./FullscreenButton"
import "@/../styles/top-navbar.css"
import DarkMode from "../ControlPanel/DarkMode"

interface TopNavbarProps {
  toggleActive: () => void
}

const TopNavbar: React.FC<TopNavbarProps> = ({ toggleActive }) => {
  useEffect(() => {
    const elementId = document.getElementById("navbar")
    const handleScroll = () => {
      if (window.scrollY > 100) {
        elementId?.classList.add("sticky")
      } else {
        elementId?.classList.remove("sticky")
      }
    }

    document.addEventListener("scroll", handleScroll)
    return () => {
      document.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className="top-navbar-dark">
      <AppBar
        id="navbar"
        color="inherit"
        sx={{
          backgroundColor: "#fff",
          boxShadow: "initial",
          borderRadius: "0 0 15px 15px",
          py: { xs: "10px", sm: "3px" },
          px: { xs: 1, sm: 2 },
          width: "100%",
          zIndex: 489,
          left: 0,
          position: "fixed",
        }}
        className="top-navbar"
      >
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 1, sm: 0 },
          }}
        >
          {/* Left section: toggle + search */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "auto",
              flexShrink: 0,
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Tooltip title="Hide/Show" arrow>
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                onClick={toggleActive}
              >
                <i className="material-symbols-outlined">menu</i>
              </IconButton>
            </Tooltip>
          </Box>

          {/* Right section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", sm: "flex-end" },
              width: "100%",
              gap: { xs: 1, sm: 2 },
              mt: { xs: 1, sm: 0 },
              flexWrap: "wrap",
            }}
          >
            <FullscreenButton />
            <DarkMode />
            <Profile />
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default TopNavbar
